import { Component, OnInit, Input } from '@angular/core';
import { EconomicGroupService } from "../../service/economic-group.service";
import { DialogService } from "ng2-bootstrap-modal";
import { FlashMessagesService } from "angular2-flash-messages/module";
import { ConfirmComponent } from "../../../shared/confirm/confirm.component";
import { EconomicGroupInsertUserComponent } from "../economic-group-insert-user/economic-group-insert-user.component";
import { Router } from '@angular/router';

@Component({
  selector: 'app-economic-group-detail',
  templateUrl: './economic-group-detail.component.html',
  styleUrls: ['./economic-group-detail.component.scss']
})
export class EconomicGroupDetailComponent implements OnInit {

  @Input('economicGroup') economicGroup;
  @Input('type') type;
  @Input('userID') userID;

  private canEdit = false;
  private groupMembers = [];
  private deleteList = [];
  private permissions;

  constructor(private economicGroupService: EconomicGroupService, private dialogService: DialogService, private flashMessagesService: FlashMessagesService, private router: Router) { }

  ngOnInit() {
    this.permissions = localStorage.getItem('yara.permissions') ? JSON.parse(localStorage.getItem('yara.permissions')) : [];
    if (this.economicGroup.StatusGrupo == "PE - Pendente para Exclusão" || this.economicGroup.StatusGrupo == "PI - Pendente para Inclusão") {
      this.canEdit = false;
    } else {
      this.canEdit = true;
    }
    this.getGroupMembers();
  }

  onSelectMember(index) {
    var tempIndex = this.deleteList.indexOf(this.groupMembers[index])
    if (tempIndex == -1) {
      this.deleteList.push(this.groupMembers[index]);
    } else {
      this.deleteList.splice(tempIndex, 1);
    }
  }

  toggleExplosaoGrupo(member: any): void {
    
    let disposable = this.dialogService.addDialog(ConfirmComponent,
      {
        title: 'Confirmar Alteração',
        message: `Deseja realmente alterar a Explosão de Grupo para o membro "${member.ClienteNome}" ?<br><br>        
        <small> Obs.: Após configurar todas as explosões de grupo, para que os ajustes sejam processados, é necessário clicar em <i class="fa fa-money fa-lg"></i><strong> Reavaliar Carteira</strong></small> .`
      },
      {
        backdropColor: 'rgba(0, 0, 0, 0.5)'
      }).subscribe((isConfirmed) => {
        
        if (isConfirmed) {
          let memberDto = {
            ContaClienteID: member.ClienteId,
            GrupoEconomicoID: this.economicGroup.GrupoId,
            ExplodeGrupo: member.ExplodeGrupo,
            ContaClienteNome: member.ClienteNome,
            GrupoEconomicoNome: this.economicGroup.GrupoNome,
          };

          this.economicGroupService.updateGroupExplosion(memberDto).subscribe(result => {
            if (result.Success) {
              member.ExplodeGrupo = !member.ExplodeGrupo;
            } else {
              this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
            }
          }, error => {
          console.log(error);
          });
        }
      });

      setTimeout(() => {
        disposable.unsubscribe();
      }, 15000);
  }

  getGroupMembers() {
    this.economicGroupService.getGroupMembers(this.economicGroup.GrupoId).subscribe(result => {
      this.groupMembers = result.Result.MembrosDetalhes;
    }, error => {
      console.log(error);
    });
  }

  changeRoute(userID) {
    this.router.navigateByUrl('/').then(
      () => {
        this.router.navigateByUrl('/conta-cliente/detalhe/' + userID);
      });
  }

  changeRouteGarantias(userID) {
    this.router.navigateByUrl('/').then(
      () => {
        this.router.navigateByUrl('/conta-cliente/detalhe/' + userID + '/garantia');
      });
  }

  onIncludeMembers() {
    this.dialogService.addDialog(EconomicGroupInsertUserComponent,
    {
      title: 'Adicionar Membro',
      groupType: this.type,
      economicGroup: this.economicGroup,
      groupMembers: this.groupMembers,
      userID: this.userID,
    },
    {
      backdropColor: 'rgba(0, 0, 0, 0.5)'
    }).subscribe((isConfirmed) => {
      //We get dialog result
      if (isConfirmed) {
        this.economicGroupService.groupsChanged.next();
        this.flashMessagesService.show("Inclusão de integrantes solicitada!", { cssClass: 'alert-success', timeout: 6000 });
      }
      else {
        //Do nothing here for now
      }
    });
  }

  onRemoveMembers() {
    var tempRemoveList = [];

    this.deleteList.forEach(element => {
      tempRemoveList.push({
        ContaClienteIDAcesso: this.userID,
        ContaClienteID: element.ClienteId,
        GrupoEconomicoID: this.economicGroup.GrupoId,
        ClassificacaoGrupoEconomicoID: this.economicGroup.ClassificacaoID
      });
    });

    var message = 'Confirma a exclusão dos integrantes selecionados?';

    let disposable = this.dialogService.addDialog(ConfirmComponent,
    {
      title: 'Confirmar Exclusão',
      message: message
    },
    {
      backdropColor: 'rgba(0, 0, 0, 0.5)'
    }).subscribe((isConfirmed) => {
      //We get dialog result
      if (isConfirmed) {
        this.economicGroupService.removeMember(tempRemoveList).subscribe(result => {
          if (result.Success) {
            this.flashMessagesService.show("Exclusão de integrantes solicitada!", { cssClass: 'alert-success', timeout: 6000 });
            this.economicGroupService.groupsChanged.next();
          } else {
            this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
          }
        }, error => {
          console.log(error);
        });
      }
      else {
        //Do nothing here
      }
    });

    setTimeout(() => {
      disposable.unsubscribe();
    }, 15000);
  }

  onRemoveGroup() {
    var message = 'Deseja realmente excluir o grupo "' + this.economicGroup.GrupoNome + '" ?';

    let disposable = this.dialogService.addDialog(ConfirmComponent,
      {
        title: 'Confirmar Exclusão',
        message: message
      },
      {
        backdropColor: 'rgba(0, 0, 0, 0.5)'
      }).subscribe((isConfirmed) => {
        //We get dialog result
        if (isConfirmed) {
          this.economicGroupService.removeGroup(this.economicGroup.GrupoId, this.userID).subscribe(result => {
            if (result.Success) {
              this.flashMessagesService.show("Exclusão de grupo solicitada!", { cssClass: 'alert-success', timeout: 6000 });
              this.economicGroupService.groupsChanged.next();
            } else {
              this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
            }
          }, error => {
            console.log(error);
          });
        }
        else {
          //Do nothing here for now
        }
      });

    setTimeout(() => {
      disposable.unsubscribe();
    }, 15000);
  }
}


// WEBPACK FOOTER //
// ./src/app/economic-group/component/economic-group-detail/economic-group-detail.component.ts